import React from 'react';

import SelectedItemsControls from '@Containers/ResultToolbar/SelectedItemsControls';
import { ButtonWithIcon } from '@els/els-react--button';
import { SlideSwitch } from '@els/els-react--slide-switch';
import RsTableToolbar from '@Pages/RetroSynthesis/components/RsTableToolbar';
import PropTypes from 'prop-types';

// eslint-disable-next-line react/function-component-definition
const RsProjectRoutesToolbar = ({
  selectedCount = 0,
  onSelectAllClick = () => null,
  isAllSelected,
  onLimitToClick = () => null,
  onDeleteClick = () => null,
  displayedItems,
  onStereospecificToggle = () => null,
  isStereospecificOnly = false,
  isPaiUser,
}) => (
  <RsTableToolbar>
    <div className="rs-table-toolbar__left-controls">
      <SelectedItemsControls
        checkAllItems={() => onSelectAllClick()}
        allItemsSelected={isAllSelected}
        currentSelectedItems={selectedCount}
        someItemsSelected={selectedCount > 0 && !isAllSelected}
      />
      <ButtonWithIcon
        data-e2e="project-routes-limit-to-button"
        layout="vertical"
        sprite="Screenshot"
        type="borderless"
        size="small"
        className="e2e-rs-toolbar-button-limit-to"
        disabled={!selectedCount || !displayedItems || displayedItems <= 1}
        onClick={onLimitToClick}>
        Limit to
      </ButtonWithIcon>
      <ButtonWithIcon
        data-e2e="project-routes-delete-button"
        layout="vertical"
        sprite="Trash"
        type="borderless"
        size="small"
        className="e2e-rs-toolbar-button-delete"
        disabled={!selectedCount || selectedCount <= 0}
        onClick={onDeleteClick}>
        Delete
      </ButtonWithIcon>
    </div>
    <div className="rs-table-toolbar__center-controls" />
    <div className="rs-table-toolbar__right-controls">
      {isPaiUser && (
        <SlideSwitch
          id="stereospecific-routes-toggle"
          data-e2e="project-routes-stereospecific-toggle"
          label="Only Stereospecific Routes"
          checked={isStereospecificOnly}
          onChange={onStereospecificToggle}
          hideLabel={false}
          showOnOffStatus={false}
        />
      )}
    </div>
  </RsTableToolbar>
);

export default RsProjectRoutesToolbar;

RsProjectRoutesToolbar.propTypes = {
  selectedCount: PropTypes.number,
  displayedItems: PropTypes.number,
  onSelectAllClick: PropTypes.func,
  isAllSelected: PropTypes.bool,
  onLimitToClick: PropTypes.func,
  onDeleteClick: PropTypes.func,
  onStereospecificToggle: PropTypes.func,
  isStereospecificOnly: PropTypes.bool,
  isPaiUser: PropTypes.bool,
};
